<template>
  <!-- <v-menu
    bottom left
    offset-y
    :min-width="500"
    :close-on-content-click="false"
    content-class="main-menu"
  >
    <div slot="activator">
      <v-btn class="no-margin" icon title="Запросити друга">
        <v-icon>person_add</v-icon>
      </v-btn>
    </div>
    <v-list>
      <invite-friend-card></invite-friend-card>
    </v-list>
  </v-menu> -->
  <!-- <div class="invite-add-button"> -->
    <v-btn class="no-margin" icon title="Запросити друга" @click="open">
      <v-icon>person_add</v-icon>

      <v-dialog v-if="popup" v-model="popup" max-width="600">
        <invite-friend-card
          @created="created"
          @canceled="popup = false"
        ></invite-friend-card>
      </v-dialog>
    </v-btn>


  <!-- </div> -->
</template>

<script>

import InviteFriendCard from '@/containers/InviteFriendCard';

export default {
  name: 'InviteFriendMenu',
  components: {
    InviteFriendCard,
  },
  data() {
    return {
      popup: false,
    };
  },
  methods: {
    open() {
      this.popup = true;
      this.$ga.event('invite-friend', 'opened', location.pathname);
    },
    created() {
      this.popup = false;
      this.$ga.event('invite-friend', 'sent', location.pathname);
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/containers/InviteFriendMenu.vue